<template>
  <div class="echars">
    <div id="echarth-xueli"></div>
  </div>
</template>

<script>
export default {
  name: "echarth-xueli",
  props:["title"],
  data() {
    return {
      data: [],
      data1:[]
    }
  },
  watch: {
        title: function (newData) {
           let value1 = newData
            value1.forEach((item,index)=>{
                
                this.data[index] = item.edu_name===''?'文盲/半文盲':item.edu_name
              
                
                this.data1[index] = item.count
                    
                    
                
            })
            this.mapFn(this.data,this.data1)
        }
    },
  methods: {
    mapFn(item,item1) {
      // 基于准备好的dom，初始化echarts实例
      // var mapChart = this.$echarts.init(this.$refs.mapChart);
      var mapChart = this.$echarts.init(
        document.getElementById("echarth-xueli")
      );
      document
        .getElementById("echarth-xueli")
        .removeAttribute("_echarts_instance_");
      mapChart.setOption({
        grid:{
          top:30
        },
        xAxis: {
          splitLine: {
            show: true,
            lineStyle: {
              type: "dashed",
              color: "#cccccc",
            },
          },
          type: "category",
          data: item,
        },
        yAxis: {
          min: 0, // 刻度最小值
          // max: 200, // 刻度最大值（需要动态获取最大值,并且能被3整除（向下取整再乘回来））
          splitNumber: 4, // 横线数
          interval: 50,
          type: "value",
          splitLine: {
            show: true,
            lineStyle: {
              type: "dashed",
              color: "#cccccc",
            },
          },
        },
        series: [
          {
            barWidth: 20,
            data: item1,
            type: "bar",
            itemStyle: {
              normal: {
                color: function (params) {
                  // 给出颜色组
                  var colorList = [
                    "#0263ff",
                    "#34a1f7",
                    "#87bfed",
                    "#b4d5f1",
                    "#4a86b6",
                    "#2382cc",
                  ];
                  //循环调用
                  return colorList[params.dataIndex % colorList.length];
                },
                label: {
                  formatter: "{c}",
                  show: true,
                  position: "top",
                  textStyle: {
                    fontWeight: "",
                    fontSize: "14",
                    color: "#333333",
                  },
                },
              },
            },
          },
        ],
      }),
        window.addEventListener("resize", () => {
          // 自动渲染echarts
          mapChart.resize();
        });
    },
  },
  mounted() {
    this.mapFn();
  },
};
</script>
<style scoped>
.echars {
  width: 40vw;
  height: 28vh;
}
#echarth-xueli {
  width: 40vw;
  height: 28vh;
}
</style>
